(function () {
  "use strict";

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", run, { once: true });
  else run();

  function run() {
    initImagemenu();
    initImagemenuMobile();
  }

  function initImagemenu() {
    document.querySelectorAll("[data-imagemenu-toggler]").forEach((toggler) => {
      toggler.addEventListener(
        "click",
        toggleMenu.bind(null, toggler, "toggle")
      );

      toggler.addEventListener(
        "mouseenter",
        toggleMenu.bind(null, toggler, "show")
      );
    });

    const menuBackground = document.querySelector(
      "[data-imagemenu-background]"
    );

    menuBackground.addEventListener("click", (e) => {
      if (e.currentTarget === e.target) hideAllMenus();
    });

    // Close on overlay hover after a short grace period rather than instantly.
    // The panel is pinned to the right edge, so reaching it from a toggler that
    // sits outside it (e.g. "Best Sellers") means crossing the overlay; closing
    // immediately made those menus impossible to click into.
    menuBackground.addEventListener("mouseenter", scheduleHideAllMenus);

    document
      .querySelectorAll("[data-imagemenu-group]")
      .forEach((megamenu) =>
        megamenu.addEventListener("mouseenter", cancelScheduledHide)
      );

    for (const menuItem of document.querySelector(".header__icons").children) {
      if (!menuItem.hasAttribute("data-imagemenu-toggler"))
        menuItem.addEventListener("mouseenter", hideAllMenus);
    }

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") hideAllMenus();
    });
  }

  function toggleMenu(toggler, mode) {
    cancelScheduledHide();

    const background = document.querySelector("[data-imagemenu-background]");
    const megamenu = document.getElementById(toggler.dataset.imagemenuToggler);
    const allMegamenus = Array.from(
      document.querySelectorAll("[data-imagemenu-group]")
    );
    const now = new Date();

    if (mode === "hide") {
      background.hidden = true;
      megamenu.hidden = true;
      return;
    }

    if (mode === "show") {
      allMegamenus.forEach((megamenu) => (megamenu.hidden = true));
      background.hidden = false;
      megamenu.hidden = false;
      toggler.dataset.showedTimestamp = now.valueOf().toString();
      return;
    }

    // mode is toggle

    if (!megamenu.hidden) {
      // Prevent from hiding when just showed 100ms ago. Solve the "'click' and 'mouseenter'
      // fired at the same time when the button is touched" issue.
      if (toggler.dataset.showedTimestamp) {
        const showedTimestamp = parseInt(toggler.dataset.showedTimestamp);
        const diff = now.valueOf() - showedTimestamp;

        if (diff < 200) return;
      }

      background.hidden = true;
      megamenu.hidden = true;
      return;
    }

    allMegamenus.forEach((megamenu) => (megamenu.hidden = true));
    background.hidden = false;
    megamenu.hidden = false;
    toggler.dataset.showedTimestamp = now.valueOf().toString();
  }

  let hideTimeout = null;

  function scheduleHideAllMenus() {
    cancelScheduledHide();
    hideTimeout = setTimeout(hideAllMenus, 400);
  }

  function cancelScheduledHide() {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  function hideAllMenus() {
    cancelScheduledHide();
    document.querySelector("[data-imagemenu-background]").hidden = true;
    document
      .querySelectorAll("[data-imagemenu-group]")
      .forEach((megamenu) => (megamenu.hidden = true));
  }

  function initImagemenuMobile() {
    document
      .querySelectorAll("[data-imagemenu-accordion-toggler]")
      .forEach((element) => initAccordion(element));

    // Reset every accordion to closed whenever the mobile menu is opened
    // via the hamburger, so no stale-open panels carry over between opens.
    document
      .querySelectorAll(".header__menu")
      .forEach((menu) =>
        menu.addEventListener("click", collapseAllAccordions)
      );
  }

  function collapseAllAccordions() {
    document
      .querySelectorAll("[data-imagemenu-accordion-toggler]")
      .forEach((toggler) => {
        const content = document.getElementById(
          toggler.dataset.imagemenuAccordionToggler
        );

        toggler.removeAttribute("aria-expanded");
        if (content) content.setAttribute("hidden", "");
      });
  }

  function initAccordion(root) {
    const target = document.querySelector(
      "#" + root.dataset.imagemenuAccordionToggler
    );

    if (!target) return;

    accordionCalculateHeight(target);

    // The card images are lazy-loaded with no reserved height, so the
    // measurement above can be too short until they load (notably on iOS
    // Safari, where no resize event fires to correct it). Recompute the
    // panel height as each image finishes loading so an open panel grows to
    // fit and a closed one has the right height ready for its next open.
    target.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener("load", () => accordionCalculateHeight(target), {
        once: true,
      });
    });

    root.addEventListener("click", accordionToggle.bind(null, root, target));

    window.addEventListener(
      "resize",
      accordionCalculateHeight.bind(null, target)
    );
  }

  function accordionCalculateHeight(target) {
    target.style.setProperty("max-height", "none");
    target.style.setProperty("--height", target.offsetHeight + "px");
    target.style.removeProperty("max-height");
  }

  function accordionToggle(root, target, event) {
    event.preventDefault();

    const isOpen = root.getAttribute("aria-expanded") === "true";

    // Enforce one open at a time: collapse all, then open the tapped one
    // (unless it was already open, in which case leave everything closed).
    collapseAllAccordions();

    if (!isOpen) {
      // Re-measure now that the menu drawer is actually visible. The
      // DOMContentLoaded measurement can be stale/too small on iOS Safari
      // (drawer hidden and/or lazy images not yet loaded at init), which
      // clipped the opened panel.
      accordionCalculateHeight(target);
      root.setAttribute("aria-expanded", "true");
      target.removeAttribute("hidden");
    }
  }
})();
